import {Requests, defaultErrorHandler} from './base'
import {resultsRequest} from './results'


function _signatureRequest (transactionId, $parent) {
  return Requests.get(`/results/${transactionId}/evaluate/signature`)
    .then(response => {
      return response.data
    })
    .catch(error => {
      return defaultErrorHandler(error, $parent)
    })
}

function _uploadToS3Request (preSignedURL, dataFile, $parent) {

  const uploadConfig = {headers: {'Content-Type': 'text/csv'}}

  return Requests.put(preSignedURL, dataFile, uploadConfig)
    .then(response => {
    })
    .catch(error => {
      return defaultErrorHandler(error, $parent)
    })
}

function _evaluateRequest (transactionId, $parent) {
  Requests.get(`/results/${transactionId}/evaluate`)
    .then(response => {
      $parent.loading.isActive = false
      $parent.evaluation.isModalActive = false
      $parent.$toast.open('評価が結果の項目に反映されます')
      resultsRequest($parent)
    })
    .catch(error => {
      return defaultErrorHandler(error, $parent)
    })
}

export default async function evaluateRequest (transactionId, file, $parent) {

  $parent.loading.isActive = true

  let signatureData = await _signatureRequest(transactionId, $parent)
  await _uploadToS3Request(signatureData.url, file, $parent)

  _evaluateRequest(transactionId, $parent)
}



// WEBPACK FOOTER //
// ./src/modules/request/evaluate.js